import { Injectable } from '@angular/core';
import { Rest, RestService } from '@ralba/shared';
import {
  OnboardingRequestExtendedDto,
  TenancyRequestDtoOfCreateOnboardingRequestInputDto,
  TenancyRequestDtoOfGuid,
} from '../dto';

@Injectable({ providedIn: 'root' })
export class ManageOnboardingHttpApiService {
  constructor(private rest: RestService) {}

  public getOnboarding(params: {
    Body: string;
    TenantId?: number | null;
    UserId?: number | null;
  }) {
    const request: Rest.Request<null> = {
      method: 'GET',
      url: '/api/manage/onboarding/get',
      params,
    };
    return this.rest.request<
      null,
      Rest.AbpResponse<OnboardingRequestExtendedDto>
    >(request);
  }

  public createOnboarding(
    body: TenancyRequestDtoOfCreateOnboardingRequestInputDto
  ) {
    const request: Rest.Request<TenancyRequestDtoOfCreateOnboardingRequestInputDto> = {
      method: 'POST',
      url: '/api/manage/onboarding/create',
      body,
    };
    return this.rest.request<
      TenancyRequestDtoOfCreateOnboardingRequestInputDto,
      Rest.AbpResponse<OnboardingRequestExtendedDto>
    >(request);
  }

  public approveOnboarding(body: TenancyRequestDtoOfGuid) {
    const request: Rest.Request<TenancyRequestDtoOfGuid> = {
      method: 'POST',
      url: '/api/manage/onboarding/approve',
      body,
    };
    return this.rest.request<
      TenancyRequestDtoOfGuid,
      Rest.AbpResponse<OnboardingRequestExtendedDto>
    >(request);
  }

  public markUserCreatedOnboarding(body: TenancyRequestDtoOfGuid) {
    const request: Rest.Request<TenancyRequestDtoOfGuid> = {
      method: 'POST',
      url: '/api/manage/onboarding/mark-user-created',
      body,
    };
    return this.rest.request<
      TenancyRequestDtoOfGuid,
      Rest.AbpResponse<OnboardingRequestExtendedDto>
    >(request);
  }

  public deleteOnboarding(params: {
    Body: string;
    TenantId?: number | null;
    UserId?: number | null;
  }) {
    // DELETE bodies are not bound to complex action params by default in
    // ASP.NET Core MVC, so the TenancyRequestDto must come via query string
    // (same shape as ManageAnnouncementHttpApiService.deleteAnnouncement).
    const request: Rest.Request<null> = {
      method: 'DELETE',
      url: '/api/manage/onboarding/delete',
      params,
    };
    return this.rest.request<null, Rest.AbpResponse<void>>(request);
  }
}
